import cn from 'classnames';

import { InlineMessageType } from '../inline-message.types';
import classes from './inline-message-icon.module.scss';

export type TInlineMessageIconProps = {
  type: InlineMessageType,
};

const ICONS = {
  'critical': 'pi-exclamation-circle',
  'high': 'pi-exclamation-circle',
  'warning': 'pi-exclamation-triangle',
  'information': 'pi-exclamation-circle',
  'success': 'pi-check-circle',
  'confirmation': 'pi-question-circle',
};

const InlineMessageIcon = (props: TInlineMessageIconProps) => {
  return <i className={cn('pi', classes.icon, classes[props.type], ICONS[props.type])} />
};

export { InlineMessageIcon };
